import { RemoveAttachmentController } from './remove-attachment-dialog.controller'

function removeAttachmentDialog () {
  return {
    restrict: 'E',
    templateUrl: '/campaigns/dialogs/remove-attachment/remove-attachment-dialog.html?$$REVISION$$',
    controller: RemoveAttachmentController
  }
}

export { removeAttachmentDialog }
